import {
  DEVICEVENDERLIST} from 'actions/deviceVender';
import {reducerPackage} from "../../utils";


export const deviceVenderList = reducerPackage(DEVICEVENDERLIST);

